import Head from "next/head";
import { useTranslation } from "next-i18next";

const ListingHead = ({
  page,
  isFirstPage,
  seoTitle,
  seoDescription,
}) => {
  const { t } = useTranslation("common");

  const displayMetaTitle = () => {
    const subTitle = seoTitle || "";
    const currentPage = isFirstPage ? "" : ` ${t("common:page")} ${page}`;

    return `${t("common:meta.name")} | ${subTitle}${currentPage}`;
  };

  return (
    <Head>
      <title data-testid="meta-title">{displayMetaTitle()}</title>
      <meta name="description" content={seoDescription} />
    </Head>
  );
};

export default ListingHead;
